import { GET_DLM_TRACKING, CLEAR_DLM_TRACKING } from "../../../Types";
// import _ from 'lodash'
const DeliverymanTrackingReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_DLM_TRACKING:
      return action.payload;
    case CLEAR_DLM_TRACKING:
      return [];
    default:
      return state;
  }
};
export default DeliverymanTrackingReportReducer;
